import { isSameDay } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';

interface Params {
  endDate?: Date;
  startDate: Date;
  timeZone: string;
}

const getCalendarEventDateString = ({
  endDate,
  startDate,
  timeZone
}: Params) => {
  let dateString = formatInTimeZone(startDate, timeZone, 'dd.MM.yyyy HH:mm');

  if (endDate) {
    dateString += ' - ';

    if (isSameDay(startDate, endDate)) {
      dateString += formatInTimeZone(endDate, timeZone, 'HH:mm');
    } else {
      dateString += formatInTimeZone(endDate, timeZone, 'dd.MM.yyyy HH:mm');
    }
  }

  return dateString;
};

export default getCalendarEventDateString;
